import React from 'react';
import moment from 'moment-timezone'; // Needed for timezone config.
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { deepMerge, deepMergeNew } from 'utils/helpers';
import { getTheme } from 'utils/themes';

// type Props = {
//   /* An additional class name. */
//   className: ?string,
//   /* Default options for chart type. */
//   defaultOptions: {},
//   /* Additional options for chart type. */
//   options: {},
//   /* Series Data array for chart */
//   data: [],
//   /* Highcharts Theme: default, dark */
//   theme: ?string,
//   /* Highcharts Type: chart, stockChart, mapChart */
//   type: ?string,
//   /* Chart Type. */
//   chartType: ?string,
//   /* timezone to set the chart to */
//   timezone: ?string,
//   /** Use deepMergeNew instead of deepMerge to create a new options object.
//    *  For example, given:
//    *  { xAxis: { labels: {}} }, { yAxis: {labels: { style: {color: blue}}}}
//    *  With deepMerge (existing/default option): xAxis labels are overwritten to be blue
//    *  { xAxis: { labels: { style: { color: blue}}}}, { yAxis: {labels: { style: {color: blue}}}}
//    *  With deepMergeNew: xAxis labels remain unstyled
//    *  { xAxis: { labels: {}} }, { yAxis: {labels: { style: {color: blue}}}}
//    */
//   useDeepMergeNew?: boolean,
// };

export default class Chart extends React.Component {
  static defaultProps = {
    theme: 'default',
  };

  state = {
    chartRef: {},
  };

  shouldComponentUpdate = () => {
    const { chartRef } = this.state;
    if (chartRef && chartRef.chart && chartRef.chart.reflow) {
      /** Rezise chart to container when data is updated. */
      chartRef.chart.reflow();
    }
    return true;
  };

  onMount = (chartRef) => {
    this.setState({ chartRef });
  };

  baseOptions = () => {
    const { chartType, data, defaultOptions, options, theme, type, useDeepMergeNew } = this.props;

    const themeDef = getTheme(theme);

    const chartOptions = {
      animation: {
        duration: 250,
      },
      backgroundColor: null,
      style: { fontFamily: "'proxima-nova', 'Proxima Nova', Helvetica Neue, Helvetica, Arial" },
    };

    if (type !== 'mapChart') {
      chartOptions.type = chartType;
    }

    const axisStyle = {
      labels: {
        style: {
          color: themeDef.axisTextColor,
        },
      },
      lineColor: themeDef.axisLineColor,
      tickWidth: 0,
      visible: true,
    };

    const baseOptions = {
      title: {
        text: '',
      },
      chart: chartOptions,
      credits: false,
      colors: themeDef.chartColors,
      xAxis: {
        gridLineWidth: 0,
        ...axisStyle,
      },
      yAxis: {
        gridLineColor: themeDef.gridLineColor,
        gridLineWidth: 1,
        title: {
          style: {
            color: themeDef.axisTextColor,
          },
        },
        ...axisStyle,
      },
      series: {
        lineWidth: 2,
      },
      tooltip: {
        backgroundColor: themeDef.tooltipBackgroundColor,
        borderRadius: 10,
        borderWidth: 0,
        hideDelay: 100,
        shadow: false,
        style: {
          color: themeDef.tooltipTextColor,
        },
      },
    };
    return useDeepMergeNew
      ? deepMergeNew(baseOptions, defaultOptions, options, data ? { series: data } : undefined)
      : deepMerge(baseOptions, defaultOptions, options, data ? { series: data } : undefined);
  };

  render() {
    const { className, type, timezone } = this.props;
    const options = this.baseOptions();
    const globalOpts = {
      lang: {
        thousandsSep: ',',
      },
    };
    if (timezone) {
      window.moment = moment;
      globalOpts.time = {
        timezone,
      };
    }
    Highcharts.setOptions(globalOpts);

    return (
      <div className={className}>
        <HighchartsReact
          highcharts={Highcharts}
          constructorType={type}
          options={options}
          update
          oneToOne
          ref={this.onMount}
        />
      </div>
    );
  }
}
